export interface Feedback {
  id?: number;
  jobId: number;
  candidateId: number;
  type: FeedbackType;
  value?: any;
  createdDate?: Date;
  lastModifiedDate?: Date;
  createdByName?: string;
  createdById?: string;
  lastModifiedByName?: string;
  lastModifiedById?: string;
}

export enum FeedbackType {
  THUMB = 'THUMB',
  BAD_MATCH_REASON = 'BAD_MATCH_REASON',
  HIRING_MANAGER_GOOD_MATCH_NOTE = 'HIRING_MANAGER_GOOD_MATCH_NOTE',
  HIRING_MANAGER_BAD_MATCH_REASON = 'HIRING_MANAGER_BAD_MATCH_REASON',
}
